export const types = {
  FILTER: 'FILTERS/FILTER',
  GET_FILTERS: 'FILTERS/GET_FILTERS',
  SET_FILTERS: 'FILTERS/SET_FILTERS',
};

export const initialState = {
  filters: null,
  status: 'none',
};

const Filters = (state = initialState, action) => {
  switch (action.type) {
    case types.FILTER:
      return JSON.parse(
        JSON.stringify({
          ...state,
          filters: action.payload,
        })
      );
    case types.GET_FILTERS:
      return {
        ...state,
        status: 'fetching',
      };
    case types.SET_FILTERS:
      return JSON.parse(
        JSON.stringify({
          ...state,
          filters: action.payload,
          status: 'success',
        })
      );
    default:
      return { ...state };
  }
};

export const actions = {
  filter: selectedFilters => ({
    type: types.FILTER,
    payload: selectedFilters,
  }),
  getFiltersBegin: () => ({ type: types.GET_FILTERS }),
  setFilters: data => ({ type: types.SET_FILTERS, payload: data }),
};

export default Filters;
